import classname from "classnames";
import { useEffect } from "react";
import PropTypes from 'prop-types';

function getClassName(error) {
    return classname({
        "eform-input": true,
        "eform-input-standard": true,
        "eform-input-error": !!error,
    });
}

const CellTextareaComponent = ({
    error,
    isReadOnly,
    schema,
    payload,
    parentProps,
    inputProps,
    setInputProps,
    updatePayload,
    validateSchema,
    getFieldValue,
}) => {
    useEffect(() => {
        setInputProps({
            ...inputProps,
            disabled: isReadOnly,
            placeholder: isReadOnly ? null : schema.description || "",
            value: getFieldValue(payload, parentProps) ?? "",
        });
    }, [payload, isReadOnly]);

    function onChange(e) {
        if (isReadOnly) return;
        const value = e.target.value;
        setInputProps({ ...inputProps, value });
        updatePayload(value);
        validateSchema(value);
    }

    const currentLength = (inputProps?.value ?? "").length;
    const maxLength = schema.maxLength;

    return (
        <div className="eform-textarea-wrapper">
            <textarea
                data-testid="eform-textarea"
                className={getClassName(error)}
                disabled={isReadOnly}
                placeholder={inputProps?.placeholder}
                value={inputProps?.value ?? ""}
                onChange={onChange}
                maxLength={maxLength || undefined}
                rows={4}
            />
            {maxLength && !isReadOnly && (
                <div className="eform-textarea-counter" data-testid="eform-textarea-counter">
                    {currentLength}/{maxLength}
                </div>
            )}
        </div>
    );
};

CellTextareaComponent.propTypes = {
    error: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    schema: PropTypes.object,
    payload: PropTypes.object,
    parentProps: PropTypes.array,
    inputProps: PropTypes.object,
    setInputProps: PropTypes.func,
    updatePayload: PropTypes.func,
    validateSchema: PropTypes.func,
    getFieldValue: PropTypes.func,
};

export default CellTextareaComponent;
